export default __webpack_public_path__ + "static/media/trr-drink-coffee-espresso.b59f3adc.png";